<template>
  <tr
    v-if="requirement.editing"
    class="requirement row experience-discipline editing"
    key="editing"
  >
    <can I="edit" a="Opportunity">
      <th v-if="first" class="text-xs-right">Experience</th>
      <td v-else class="text-xs-right">
        {{ requirement.mandatory ? 'and' : 'or' }}
      </td>
      <td colspan="2">
        <v-toolbar flat class="transparent">
          <v-select
            v-model="requirement.mandatory"
            :items="[{ text: 'must', value: true }, { text: 'could', value: false }]"
          />
          <label class="body px-2"></label>
          <v-select
            v-model="requirement.negative"
            :items="[{ text: 'not have', value: true }, { text: 'have', value: false }]"
          />
          <label class="body px-2">discipline</label>
          <v-select
            multiple
            return-object
            v-if="disciplines.length > 0"
            v-model="requirement.disciplines"
            @input="setValue"
            :items="disciplines"
            item-text="name"
          />

          <v-spacer />

          <!-- Cancel Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small flat fab slot="activator" @click="cancel" key="cancel" color="grey">
              <v-icon>mdi-cancel</v-icon>
            </v-btn>
            <span>Cancel</span>
          </v-tooltip>
          <!-- Delete Button -->
          <v-tooltip left v-if="requirement.id" color="grey darken-3">
            <v-btn small flat error fab slot="activator" @click="destroy" key="delete" color="error">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span>Delete</span>
          </v-tooltip>
          <!-- Submit Button -->
          <v-tooltip left color="grey darken-3">
            <v-btn small fab key="save" @click="submit" slot="activator" color="primary">
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <span v-if="requirement.id">Update</span>
            <span v-else>Create</span>
          </v-tooltip>
        </v-toolbar>
      </td>
    </can>
  </tr>
  <tr v-else class="requirement row experience-discipline viewing" key="viewing">
    <th v-if="first" class="text-xs-right">Experience</th>
    <td v-else class="text-xs-right">
      {{ requirement.mandatory ? 'and' : 'or' }}
    </td>
    <td>
      {{ requirement.mandatory ? 'must' : 'could' }}
      {{ requirement.negative ? 'not' : '' }}
      have discipline
      <span v-for="discipline in requirement.disciplines" :key="`discipline-${discipline.id}`">
        {{ discipline != requirement.disciplines[0] ? 'or' : '' }}
        <v-chip label>{{ discipline.name }}</v-chip>
      </span>
    </td>
    <td class="text-xs-right">
      <can I="edit" a="Opportunity">
        <v-btn small flat @click.prevent="edit" color="primary">
          Edit
        </v-btn>
      </can>
    </td>
  </tr>
</template>

<script>
// Vue Component
export default {
  props: {
    requirement: { type: Object, required: true },
    first: { type: Boolean },
  },
  created() {
    this.$http.get('disciplines').then(response => {
      // Set options
      let options = response.data

      // In-place sort by display attribute (case insensitive)
      options.sort((a, b) => {
        const first = a['name'].toUpperCase()
        const second = b['name'].toUpperCase()

        if (first < second) return -1
        if (first > second) return 1
        return 0
      })

      // Store options
      this.disciplines = options
    })
  },
  data() {
    return {
      disciplines: [],
    }
  },
  computed: {
    creating() {
      return this.requirement.id == null
    },
  },
  methods: {
    edit() {
      this.requirement.editing = true
    },
    setValue(selected) {
      this.requirement.disciplines = selected
      this.requirement.value = this.requirement.disciplines.map(d => d.id).join(',')
    },
    cancel() {
      this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      this.requirement.editing = false
    },
    destroy() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/destroy', this.requirement)
      } else {
        this.$store.dispatch('opportunities/fetch', this.$route.params.id)
      }
    },
    submit() {
      if (this.requirement.id) {
        this.$store.dispatch('requirements/update', this.requirement).then(feedback => {
          if (feedback) {
            this.$store.commit('snackbar', {
              text: 'There was a problem updating the requirement',
              type: 'error',
            })
            this.requirement = feedback
          } else {
            this.$store.commit('snackbar', {
              text: 'Requirement was updated successfully',
              type: 'success',
            })
          }
        })
      } else {
        this.$store.dispatch('requirements/create', this.requirement).then(feedback => {
          if (feedback) {
            this.$store.commit('snackbar', {
              text: 'There was a problem creating the requirement',
              type: 'error',
            })
            this.requirement = feedback
          } else {
            this.$store.commit('snackbar', {
              text: 'Requirement was created successfully',
              type: 'success',
            })
          }
        })
      }
    },
  },
}
</script>
